// @flow
import {
  actions as NotifModuleActions,
  initialState as NotifModuleInitialState
} from './notifications/duck';
import NotifModuleReducer from './notifications/duck';

import type { NotificationsState, NotificationsAction } from './notifications/duck';

type NavbarAction = {
  +type: string;
};

export type NavbarState = {
  notifications: NotificationsState;
};

// Action creators
// No action creators for the moment, all from notifications sub-module
export const initialState = {
  notifications: NotifModuleInitialState,
};

// Reducer
export default function reducer(state: NavbarState = initialState,
                                action: NavbarAction | NotificationsAction): NavbarState {
  switch (action.type) {
    case NotifModuleActions.NOTIFICATIONS_NOOP:
    case NotifModuleActions.NOTIFICATIONS_RESET_STATE:
    case NotifModuleActions.NOTIFICATIONS_FETCH_REQUEST:
    case NotifModuleActions.NOTIFICATIONS_FETCH_SUCCESS:
    case NotifModuleActions.NOTIFICATIONS_FETCH_ERROR:
    case NotifModuleActions.NOTIFICATIONS_FETCH_UNSEEN_REQUEST:
    case NotifModuleActions.NOTIFICATIONS_FETCH_UNSEEN_SUCCESS:
    case NotifModuleActions.NOTIFICATIONS_SEE_ALL_REQUEST:
    case NotifModuleActions.NOTIFICATIONS_HIDE_REQUEST:
    case NotifModuleActions.NOTIFICATIONS_READ_REQUEST:
    case NotifModuleActions.NOTIFICATIONS_NEW_REALTIME:
      return {
        notifications: NotifModuleReducer(state.notifications, (action: any)),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/navbar/duck.js